import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { addVendor } from 'store/thunks/vendorManagementThunk';

const AddVendorDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const [vendor, setVendor] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [duplicateError, setDuplicateError] = useState(false);

  const handleClose = () => {
    setVendor('');
    setDuplicateError(false);
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!vendor.trim()) return;

    setSubmitting(true);
    setDuplicateError(false);

    dispatch(
      addVendor({
        vendor: vendor.trim(),
        onSuccess: () => {
          setSubmitting(false);
          handleClose();
        },
        onDuplicate: () => {
          setSubmitting(false);
          setDuplicateError(true);
        },
      })
    ).finally(() => setSubmitting(false));
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='xs' fullWidth>
      <DialogTitle>Add Vendor</DialogTitle>
      <form onSubmit={handleSubmit} noValidate>
        <DialogContent sx={{ pt: 1 }}>
          <TextField
            label='Vendor Name'
            required
            fullWidth
            autoFocus
            value={vendor}
            onChange={(e) => {
              setVendor(e.target.value);
              if (duplicateError) setDuplicateError(false);
            }}
            inputProps={{ maxLength: 50 }}
            error={duplicateError}
            helperText={
              duplicateError ? (
                <Typography variant='caption' color='error'>
                  A vendor with this name already exists.
                </Typography>
              ) : (
                ''
              )
            }
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleClose} color='secondary'>
            Cancel
          </Button>
          <LoadingButton
            loading={submitting}
            type='submit'
            variant='contained'
            disabled={!vendor.trim()}
          >
            Add
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

AddVendorDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddVendorDialog;
